import {
  MAX_PRIMARY_ENTITY_SELECTIONS,
  SelectionCategories,
} from '@revelio/iso-utility';

import { FilterId } from '../types/filters';

export const ACTIVITY_FILTER_POPOUT_WIDTH = 380;

export const TOO_MANY_CHART_ENTITIES_ERROR_MESSAGE = `Too many entities are selected. Please select up to ${MAX_PRIMARY_ENTITY_SELECTIONS} entities.`;

export const ROLE_GRANULARITY_FILTERS = [
  SelectionCategories.JOB_CATEGORY,
  SelectionCategories.ROLE_K150,
  SelectionCategories.ROLE_K1500,
];

export const GEOGRAPHY_GRANULARITY_FILTERS = [
  SelectionCategories.REGION,
  SelectionCategories.COUNTRY,
  SelectionCategories.METRO_AREA,
];

export const RICS_FILTERS = [
  SelectionCategories.RICS_K10,
  SelectionCategories.RICS_K400,
];

/**
 * The internal taxonomy VALUE filters (never user-pickable, never rendered as
 * chips). Single source of truth for the screener strips, the filter-select
 * modal's exclusions, and URL version stamping.
 */
const TAXONOMY_FILTER_IDS = [
  FilterId.ROLE_TAXONOMY,
  FilterId.SKILL_TAXONOMY,
  FilterId.ACTIVITY_TAXONOMY,
] as const;

export const isTaxonomyFilterId = (id: string): boolean =>
  (TAXONOMY_FILTER_IDS as readonly string[]).includes(id);

export const CORRECTION_PREFERENCE_FILTER_IDS: readonly FilterId[] = [
  FilterId.DATA_ADJUSTMENTS,
  FilterId.CONTINGENT_WORKERS,
];

const ORDERED_FLAT_SELECTION_FILTER_IDS: readonly FilterId[] = [
  FilterId.EDUCATION,
  FilterId.OVERALL_RATING,
  FilterId.SENIORITY,
  FilterId.FUNDING_STAGE,
  FilterId.FLIGHT_RISK,
  FilterId.PRESTIGE,
  FilterId.REMOTE_SUITABILITY,
];

export const shouldSortSelectedFlatFilterOptions = (id: FilterId): boolean =>
  !ORDERED_FLAT_SELECTION_FILTER_IDS.includes(id);
